import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { LeadModalProvider } from "@/components/site/SiteContext";
import { previewConfigMissing, school } from "@/data/schoolData";
import { FreeWeekModal } from "@/components/site/FreeWeekModal";
import HomePage from "@/pages/HomePage";
import { ProgramPage, ProgramsPage } from "@/pages/ProgramsPage";
import { AboutPage, InstructorsPage, ReviewsPage } from "@/pages/GeneralPagesA";
import { ContactPage, FreeWeekPage, SchedulePage as ScheduleOverviewPage } from "@/pages/GeneralPagesB";
import { ConfirmationPage } from "@/pages/BookingPages";
import { LegalPage, NotFoundPage } from "@/pages/LegalPages";
import PreviewPage from "@/pages/PreviewPage";
import AdminPage from "@/pages/AdminPage";
import MarkupPage from "@/pages/MarkupPage";
import CustomerPage from "@/pages/CustomerPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const { pathname } = useLocation();
  if (previewConfigMissing && !pathname.startsWith("/preview/") && !pathname.startsWith("/markup")) return <><ScrollToTop /><div className="preview-state" data-testid="preview-config-missing">This preview is not available yet.</div></>;
  return <><ScrollToTop /><Routes><Route path="/" element={<HomePage />} /><Route path="/programs" element={<ProgramsPage />} /><Route path="/preview/:siteId" element={<PreviewPage />} /><Route path="/admin/*" element={<AdminPage />} /><Route path="/markup" element={<MarkupPage />} /><Route path="/customer/*" element={<CustomerPage />} /><Route path="/:slug" element={<ProgramRoute />} /><Route path="/about" element={<AboutPage />} /><Route path="/instructors" element={<InstructorsPage />} /><Route path="/schedule" element={<ScheduleOverviewPage />} /><Route path="/confirmation" element={<ConfirmationPage />} /><Route path="/reviews" element={<ReviewsPage />} /><Route path="/free-week" element={<FreeWeekPage />} /><Route path="/contact" element={<ContactPage />} /><Route path="/privacy" element={<LegalPage type="privacy" />} /><Route path="/terms" element={<LegalPage type="terms" />} /><Route path="*" element={<NotFoundPage />} /></Routes></>;
}

function ProgramRoute() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+|\/+$/g, "");
  if (![...school.programs, ...(school.offerings || [])].some((program) => program.slug === slug)) return <NotFoundPage />;
  return <ProgramPage />;
}

export default function App() {
  return <LeadModalProvider><BrowserRouter><AppRoutes /><FreeWeekModal /></BrowserRouter></LeadModalProvider>;
}
